import { render, staticRenderFns } from "./recovery-certificate-component.vue?vue&type=template&id=e4fa21f0&"
import script from "./recovery-certificate-component.vue?vue&type=script&lang=js&"
export * from "./recovery-certificate-component.vue?vue&type=script&lang=js&"
import style0 from "./recovery-certificate-component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports